
import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

interface SystemUpdateModalProps {
    isOpen: boolean;
    version: string;
}

export const SystemUpdateModal: React.FC<SystemUpdateModalProps> = ({
    isOpen,
    version
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                className="relative w-full max-w-lg bg-white dark:bg-zinc-900 rounded-2xl shadow-2xl border border-zinc-200 dark:border-zinc-800 overflow-hidden"
                role="dialog"
                aria-modal="true"
            >
                {/* Header Decoration */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-orange-500 to-red-600" />

                <div className="p-6">
                    <div className="mb-4">
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                            עדכון מערכת זמין
                        </h2>
                        <p className="text-gray-600 dark:text-gray-300 text-base leading-relaxed">
                            קיים עדכון גרסה למערכת (גרסה {version}).
                            <br />
                            על מנת להמשיך להשתמש בה יש לבצע עדכון גרסה.
                        </p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3 mt-6">
                        <a
                            href="/installers/windows/CloserAudio-x64-Setup.msi"
                            download
                            className="flex-1 inline-flex items-center justify-center px-4 py-2.5 rounded-xl bg-orange-600 text-white font-medium hover:bg-orange-700 transition-all shadow-lg shadow-orange-500/20 gap-2"
                        >
                            <ArrowDownTrayIcon className="w-5 h-5" />
                            <span>Windows</span>
                        </a>
                        <a
                            href="/installers/mac/CloserAudio-Setup.pkg"
                            download
                            className="flex-1 inline-flex items-center justify-center px-4 py-2.5 rounded-xl bg-orange-600 text-white font-medium hover:bg-orange-700 transition-all shadow-lg shadow-orange-500/20 gap-2"
                        >
                            <ArrowDownTrayIcon className="w-5 h-5" />
                            <span>macOS</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
